import type { SpartacuxStateWithCustomerFinanceOperations } from '@/domains/customerFinanceOperations/interfaces/CustomerFinanceOperationsState';
import type {
  CreditCardStatus,
  ErrorStatus,
  FiscalCode,
  InvoiceStatus,
  PageStatus,
  RecipientCodeStatus,
} from '@/domains/customerFinanceOperations/Payment/interfaces/PageStatus';

import type { CouponStatusState } from '../reducers/PageStatus/couponStatus.reducer';
import type { PaymentMethod } from '../services/purchaseIntent/interfaces';
import { selectPaymentPage } from './rootSelectors';

export const selectPaymentPageStatus = (
  state: SpartacuxStateWithCustomerFinanceOperations,
): PageStatus | undefined => selectPaymentPage(state)?.pageStatus;

export const selectCreditCardStatus = (
  state: SpartacuxStateWithCustomerFinanceOperations,
): CreditCardStatus | undefined => selectPaymentPageStatus(state)?.creditCard;

export const selectErrorStatus = (
  state: SpartacuxStateWithCustomerFinanceOperations,
): ErrorStatus | undefined | null =>
  selectPaymentPageStatus(state)?.errorStatus;

export const selectInvoiceStatus = (
  state: SpartacuxStateWithCustomerFinanceOperations,
): InvoiceStatus | undefined => selectPaymentPageStatus(state)?.invoiceStatus;

export const selectFiscalCode = (
  state: SpartacuxStateWithCustomerFinanceOperations,
): FiscalCode | undefined => selectPaymentPageStatus(state)?.fiscalCode;

export const selectSelectedPaymentMethod = (
  state: SpartacuxStateWithCustomerFinanceOperations,
): PaymentMethod | null | undefined =>
  selectPaymentPageStatus(state)?.selectedPaymentMethod;

export const selectIsProcessingPayment = (
  state: SpartacuxStateWithCustomerFinanceOperations,
): boolean => selectPaymentPageStatus(state)?.processingPayment || false;

export const selectPageIsFetching = (
  state: SpartacuxStateWithCustomerFinanceOperations,
): boolean | null | undefined => selectPaymentPageStatus(state)?.isFetching;

export const selectCouponStatus = (
  state: SpartacuxStateWithCustomerFinanceOperations,
): CouponStatusState | undefined =>
  selectPaymentPageStatus(state)?.couponStatus;

export const selectRecipientCodeStatus = (
  state: SpartacuxStateWithCustomerFinanceOperations,
): RecipientCodeStatus | undefined =>
  selectPaymentPageStatus(state)?.recipientCodeStatus;

export const selectIsFetchingValidatePayment = (
  state: SpartacuxStateWithCustomerFinanceOperations,
): boolean | null | undefined =>
  selectPaymentPageStatus(state)?.isFetchingValidatePayment;
